import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { MainComponent, MaxDirective, MinDirective} from './components/main/main.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import {ToastrModule} from "ngx-toastr";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AuthInterceptor} from "./auth.service";
import { RedirectGuard } from './guards/redirect.guard';
import {CookieService} from "ngx-cookie-service";
import {analytics} from 'noc-analytics';
import {NOC_ANALYTICS} from 'ngx-shared-services';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxGlobalContactFooterModule } from 'ngx-global-contact-footer';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MaxDirective,
    MinDirective,
    LoadingScreenComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-full-width',
      closeButton: true
    }),
    NgxGlobalContactFooterModule.forRoot({namespace: 'ngx-global-contact-footer.'}),
    NgxGlobalContactFooterModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: NOC_ANALYTICS, useValue: analytics },
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: '/assets/i18n/', suffix: '.json' } },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(_http: HttpClient) {
  return new TranslateHttpLoader();
}
